import React from 'react';

const Articles = () => {
    return (
        <div className='bg-white text-black pt-20'>
            
            <h1 className='text-center font-bold text-3xl'>We have thoughts, and we think we</h1>
            <h1 className='text-center font-bold text-3xl'>should share them with you.</h1>
            <div>
            <div className='grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 m-32 gap-36'>
<div class="card card-compact  bg-base-100 ">
  <figure><img src="https://images.prismic.io/instrument-v5/2be600e5-ae3e-4df1-90dc-ff98202d35bb_1_VR_RemoteWork_Illustrations+220624_Color1.jpg?auto=compress,format&w=1280" alt="Shoes" /></figure>
  <div class="card-body  ">
    <h2 class="card-title">Work, Life, Wherever: Our Evolution as a Virtual First Company</h2>
   
   
  </div>
</div>
<div class="card card-compact bg-base-100 ">
  <figure><img src="https://images.prismic.io/instrument-v5/f43c62bc-9a19-4771-a13e-b8b0d93e6d6b_72andsunny-nyc_ISAKTINER-8376-edit.jpg?auto=compress,format&w=1280" alt="Shoes" /></figure>
  <div class="card-body ">
    <h2 class="card-title">The Start Of a new Chapter with Kara place</h2>

    
  </div>
</div>
</div>
            <div className='grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 m-32 gap-36'>
<div class="card card-compact  bg-base-100 ">
  <figure><img src="https://images.prismic.io/instrument-v5/6ae83898-848a-45f0-b93b-7d19ee2547c2_DBX_article.jpg?auto=compress,format&w=1280" alt="Shoes" /></figure>
  <div class="card-body  ">
    <h2 class="card-title">Work, Life, Wherever: Our Evolution as a Virtual First Company</h2>
   
   
  </div>
</div>
<div class="card card-compact bg-base-100 ">
  <figure><img src="https://images.prismic.io/instrument-v5/9c37492b-aaba-46c4-bbc6-ade57c376bf0__artwork.jpg?auto=compress,format&w=1280" alt="Shoes" /></figure>
  <div class="card-body ">
    <h2 class="card-title">The experience of brands in the real world (and beyond).</h2>

    
  </div>
</div>
</div>
            <div className='grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 m-32 gap-36'>
<div class="card card-compact  bg-base-100 ">
  <figure><img src="https://images.prismic.io/instrument-v5/d0e17b60-8671-4e29-95f6-ee80f081a164__bombis.jpg?auto=compress,format&w=1280" alt="Shoes" /></figure>
  <div class="card-body  ">
    <h2 class="card-title">Mapping Dominant Image Colors in Javascript</h2>
   
   
  </div>
</div>
<div class="card card-compact bg-base-100 ">
  <figure><img src="https://images.prismic.io/instrument-v5/27cb0712-2030-43d6-a1d9-43c4bf5677b0__closer.jpg?auto=compress,format&w=1280" alt="Shoes" /></figure>
  <div class="card-body ">
    <h2 class="card-title">Are we closer to the truth?</h2>

    
  </div>
</div>
</div>
            <div className='grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 m-32 gap-36'>
<div class="card card-compact  bg-base-100 ">
  <figure><img src="https://images.prismic.io/instrument-v5/df84185d-8895-45fb-a8b5-f9bab7a4e732__dotcom-thumbnail.png?auto=compress,format&w=1280" alt="Shoes" /></figure>
  <div class="card-body  ">
    <h2 class="card-title">Commititng to change</h2>
   
   
  </div>
</div>
<div class="card card-compact bg-base-100 ">
  <figure><img src="https://images.prismic.io/instrument-v5/9c980c82-33c5-4567-9584-64e357fe590a_hd_1b%402x.png?auto=compress,format&w=1280" alt="Shoes" /></figure>
  <div class="card-body ">
    <h2 class="card-title">Human Development</h2>

    
  </div>
</div>
</div>
            </div>
        </div>
    );
};

export default Articles;